import script from "./TechnologyAssetsComparisonCriteriaModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsComparisonCriteriaModal.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyAssetsComparisonCriteriaModal.vue?vue&type=style&index=0&id=6f0ccada&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f0ccada"]])

export default __exports__